/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PhoneAuthType } from './phoneAuthType';


export interface PhoneNumberVerification { 
    phone_number: string;
    code: string;
    auth_type: PhoneAuthType | null;
}

